import { useState } from "react";


/**
 * Hook for validating a form using JavaScript validation API
 *
 * All elements to be validated must have a name attribute
 *
 * @param {object} initialState
 * @param {function} translator
 */
const useFormValidation = (initialState = {}, translator = (key) => key) => {
  const [validationErrors, setValidationErrors] = useState(initialState);

  const errors = {};

  const validate = (form) => {
    let hasErrors = false;

    Array.from(form.elements)
      .forEach(element => {

        if (!element.name) {
          return;
        }

        if (!element.checkValidity()) {
          const error = Object.getOwnPropertyNames(Object.getPrototypeOf(element.validity))
            .find((propName) => element.validity[propName]);

          errors[element.name] = translator('common:validationErrors.' + error);
          hasErrors = true;
        } else {
          errors[element.name] = '';
        }
      });

    setValidationErrors(errors);

    return !hasErrors;
  };

  return [validationErrors, validate];
};

export {
  useFormValidation
};
